import * as Elements from "../../presentation";
import React, { useContext, useState, useEffect, useReducer } from "react";
import AccountContext from "../../../context/accounts/accountContext";
import IstavrityContext from "../../../context/istavrity/istavrityContext";
import SpinnerContext from "../../../context/spinner/spinnerContext";
import AlertContext from "../../../context/alert/alertContext";
import Enums from "../../../enums/Enums";

export const OnePageProfile = (props) => {
  const alertContext = useContext(AlertContext);
  const { setAlert } = alertContext;
  const account = props.history.location.state;
  const { _id } = account;
  const initState = {
    name: "",
    address: {},
    email: "",
    phone: "",
    fcnum: "",
    accountLocked: false,
    passwordLocked: false,
    members: [],
    libraryMemberType: "",
    externalUser: false,
    moderator: false,
  };
  const [state, setState] = useState(initState);
  const {
    name,
    address,
    email,
    phone,
    fcnum,
    accountLocked,
    passwordLocked,
    members,
    libraryMemberType,
    externalUser,
    moderator,
  } = state;

  useEffect(() => {
    const loadUser = async (_id) => {
      startSpinner();
      let res = await getUserById(_id);
      setState(res);
      stopSpinner();
    };
    loadUser(_id);
  }, []);

  const {
    line1 = "",
    line2 = "",
    suburb = "",
    state: region = "",
    postcode = "",
  } = address;
  const accountContext = useContext(AccountContext);
  const istavrityContext = useContext(IstavrityContext);
  const spinnerContext = useContext(SpinnerContext);

  const {
    impersonate,
    changeAccountStatus,
    getUserById,
    setLibraryMemberType,
    toggleModerator,
    getResetPasswordLink,
    user,
    toggleExternalUser
  } = accountContext;
  const { startSpinner, stopSpinner } = spinnerContext;

  const impersonateUser = async (e) => {
    await impersonate(email);
    istavrityContext.clearDeposits();
    props.history.push("/home");
    //window.location.reload();
  };

  const lockUnlockUser = async () => {
    startSpinner();
    try {
      const desiredStatus = !(accountLocked && passwordLocked);
      let res = await changeAccountStatus({ fcnum, status: desiredStatus });
      window.alert(res.data.data.msg);
      setState({ ...state, accountLocked: desiredStatus, passwordLocked: desiredStatus });
    } catch (error) {
      window.alert(error.response.data.msg);
      // setAlert({type:"danger",msg:error.response.data.msg})
    }
    stopSpinner();
  };

  const setLibraryAccountType = async (type) => {
    startSpinner();
    try {
      let res = await setLibraryMemberType(fcnum, type);
      console.log("Res:", res);
      window.alert(res.msg);
      setState({ ...state, libraryMemberType: type });
    } catch (error) {
      window.alert(error.response.data.msg);
      // setAlert({type:"danger",msg:error.response.data.msg})
    }
    stopSpinner();
  };

  const getLibraryMemberType = (memberType) => {
    if (!memberType) return "NA";
    console.log("MemberType:", memberType);
    console.log(
      Object.entries(Enums.LIBRARY_ACCOUNT_TYPE).find(
        ([key, value]) => value === memberType
      )
    );
    return Object.entries(Enums.LIBRARY_ACCOUNT_TYPE).find(
      ([key, value]) => +value === +memberType
    )[0];
  };

  const toggleModeratorValue = async (e) => {
    startSpinner();
    try {
      let res = await toggleModerator(_id);
      window.alert(res.msg);
      setState({ ...state, moderator: !moderator });
    } catch (error) {
      window.alert(error.response.data.msg);
      // setAlert({type:"danger",msg:error.response.data.msg})
    }
    stopSpinner();
  };

  const toggleExternalUserValue = async (e) => {
    startSpinner();
    try {
      let res = await toggleExternalUser(_id);
      window.alert(res.msg);
      setState({ ...state, externalUser: !externalUser });
    } catch (error) {
      window.alert(error.response.data.msg);
      // setAlert({type:"danger",msg:error.response.data.msg})
    }
    stopSpinner();
  };

  const getPasswordResetLink = async () => {
    startSpinner();
    try {
      let res = await getResetPasswordLink(email);
      // copy the link to clipboard
      navigator.clipboard.writeText(res.msg);
      //window.alert(res.msg);
      setAlert({type:"success",msg:"The password reset link has been copied to clipboard."});
    } catch (error) {
      window.alert(error.response.msg);
      // setAlert({type:"danger",msg:error.response.data.msg})
    }
    stopSpinner();
  }

  return (
    <div>
      <br></br>
      <button
        className=" uk-button uk-button-secondary uk-button-link  uk-text-large uk-text-underline uk-align-right"
        onClick={impersonateUser}
      >
        IMPERSONATE MEMBER
      </button>
      <div>
        <h4 className="uk-text-lead uk-text-bold uk-text-center uk-padding-large uk-margin-top">
          <u>MEMBER PROFILE</u>
        </h4>
      </div>

      <div className="uk-grid uk-grid-divider uk-margin-top uk-child-width-1-2@s uk-padding-large uk-margin-top uk-padding-remove-bottom">
        <div>
          <span
            className="uk-margin-small-right "
            uk-icon="icon: user;ratio: 1.5"
          ></span>
          <span className="uk-text- uk-text-large">{name}</span>
        </div>
        <div>
          <span
            className="uk-margin-small-right"
            uk-icon="icon: mail ;ratio: 1.5"
          ></span>
          <span className="uk-text- uk-text-large">{email}</span>
        </div>
        <div>
          <span className="uk-text uk-text-bold uk-text-large">
            Family Code:
          </span>
          <span className="uk-text uk-text-large">{fcnum}</span>
        </div>
        <div>
          <span className="uk-text uk-text-bold uk-text-large">Phone:</span>
          <span className="uk-text- uk-text-large">{phone}</span>
        </div>
        <div className="uk-margin">
          <span className="uk-text uk-text-bold uk-text-large">Address:</span>
          <span className="uk-text- uk-text-large">
            {line1},{line2},{suburb},{region},{postcode}
          </span>
        </div>
        {user.role === Enums.ACCOUNT_TYPE.COUNTRY_ADMIN && (
          <>
           <div className="uk-margin">
          <span className="uk-text uk-text-bold uk-text-large">
            Library Member Type:
          </span>
          <span className="uk-text- uk-text-large">
            {getLibraryMemberType(libraryMemberType + "")}
          </span>
          <Elements.Button
            name="libraryStateAdmin"
            register={() => {}}
            label={"Set as State Librarian"}
            className={"uk-button uk-button-success"}
            onClick={async () =>
              await setLibraryAccountType(
                Enums.LIBRARY_ACCOUNT_TYPE.STATE_ADMIN
              )
            }
            show={libraryMemberType != Enums.LIBRARY_ACCOUNT_TYPE.STATE_ADMIN}
          />
          <Elements.Button
            name="libraryAdmin"
            register={() => {}}
            label={"Set as Country Librarian"}
            className={"uk-button uk-button-primary"}
            onClick={() =>
              setLibraryAccountType(Enums.LIBRARY_ACCOUNT_TYPE.ADMIN)
            }
            show={libraryMemberType != Enums.LIBRARY_ACCOUNT_TYPE.ADMIN}
          />
          <Elements.Button
            name="libraryMember"
            register={() => {}}
            label={"Set as Library Member"}
            className={"uk-button uk-button-secondary"}
            onClick={() =>
              setLibraryAccountType(Enums.LIBRARY_ACCOUNT_TYPE.MEMBER)
            }
            show={libraryMemberType != Enums.LIBRARY_ACCOUNT_TYPE.MEMBER}
          />
          
        </div>
        <div>
           <div>
           <button
              className="uk-button uk-button-secondary uk-align-center"
              onClick={getPasswordResetLink}
            >
              Get Password Reset Link
            </button>
          
            
          </div>
        <div>
            <label className="uk-text uk-text-bold uk-text-large">
              Moderator:
            </label>
            <input type="checkbox"
              className="uk-checkbox uk-margin-small-left"
              checked={moderator}
              onChange={toggleModeratorValue}
              />
            
          </div>
        <div>
            <label className="uk-text uk-text-bold uk-text-large uk-disabled">
              External User:
            </label>
            <input type="checkbox"
              className="uk-checkbox uk-margin-small-left"
              checked={externalUser}
              onChange={toggleExternalUserValue}
              />
            
          </div>
       </div>
        <div className="uk-margin">
          <span className="uk-text uk-text-bold uk-text-large">
            Account Status:
          </span>
          <span className="uk-text- uk-text-large">
            {accountLocked || passwordLocked ? "LOCKED" : "ACTIVE"}
          </span>
          <div>
            <Elements.Button
              name="lockunlockstatus"
              register={() => {}}
              label={accountLocked || passwordLocked ? "UNLOCK" : "LOCK"}
              className={
                accountLocked || passwordLocked
                  ? "uk-button uk-button-success"
                  : "uk-button uk-button-danger"
              }
              onClick={lockUnlockUser}
            />
          </div>

          
        </div> </>)}
      </div>
      <div className="uk-grid uk-grid-divider uk-margin-top uk-child-width-1-2@m uk-padding-large uk-padding-remove-top uk-padding-remove-bottom"></div>

      <hr className="uk-divider-icon"></hr>

      <div className="uk-container-expand">
        <table
          id="allaccounts"
          className="uk-table uk-table-striped uk-table-divider"
        >
          <thead>
            <tr>
              <th> Name</th>
              <th> Ritwik Name</th>
              <th> Member Type</th>
            </tr>
          </thead>

          <tbody>
            {members.map((member) => (
              <tr key={member.name}>
                <td className="uk-text uk-text-center">{member.name}</td>
                <td className="uk-text uk-text-center">
                  {member.memberType ? member.ritwik.fullName : "NA"}
                </td>
                <td className="uk-text-capitalize">
                  {Enums.MEMBER_TYPES[member.memberType]}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <button
        className="uk-button uk-button-primary uk-align-center"
        onClick={() => props.history.goBack()}
      >
        BACK
      </button>
    </div>
  );
};
